import { HingeBoreLocations, PreHangCartOptions } from "@/types/preHang";
import { PreHangCache } from "./ph-cache";

export class CustomHingeBoreLocations {
    public noHingePrep = false
    public locations: HingeBoreLocations
    private Cache: PreHangCache

    public constructor(preHangOptions: PreHangCartOptions | null, Cache: PreHangCache) {
        this.Cache = Cache
        const cacheSelections = this.Cache.cachedSelections
        this.noHingePrep = preHangOptions?.noHingePrep || cacheSelections.noHingePrep || false
        this.locations = {
            hingeOne: preHangOptions?.hingeOne || cacheSelections.hingeOne || null,
            hingeTwo: preHangOptions?.hingeTwo || cacheSelections.hingeTwo || null,
            hingeThree: preHangOptions?.hingeThree || cacheSelections.hingeThree || null,
            hingeFour: preHangOptions?.hingeFour || cacheSelections.hingeFour || null,
            boreOne: preHangOptions?.boreOne || cacheSelections.boreOne || null,
            boreTwo: preHangOptions?.boreTwo || cacheSelections.boreTwo || null
        }
    }

    public updateLocations(locations: HingeBoreLocations) {
        this.locations = locations
        Object.entries(this.locations).forEach(([key, value]) => {
            this.Cache.addToCache(key, value)
        })
    }
    
    public updateNoHingePrep(hingePrep: boolean) {
        this.noHingePrep = hingePrep
        this.Cache.addToCache('noHingePrep', this.noHingePrep)
    }
}